import { Navigate, useLocation } from 'react-router-dom';
import { useProfile } from '../services/auth.service';
import { Layout } from './layout/Layout';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireCompany?: boolean;
}

export const ProtectedRoute = ({ children, requireCompany = true }: ProtectedRouteProps) => {
  const location = useLocation();
  const { data: user, isLoading, isError } = useProfile();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <p className="text-secondary">Loading...</p>
        </div>
      </div>
    );
  }

  if (isError || !user) {
    const currentPath = location.pathname + location.search;
    const redirectUrl = encodeURIComponent(currentPath);
    return <Navigate to={`/login?redirect=${redirectUrl}`} replace />;
  }

  if (requireCompany && !user.hasCompany && location.pathname !== '/company-settings') {
    return <Navigate to="/company-settings" replace />;
  }

  return <Layout>{children}</Layout>;
};
